import {LoaderCircle,RefreshCw} from 'lucide-react';
import type {AuthBootstrapState} from '../auth-bootstrap';
import appIcon from '../assets/branding/reados-app-icon-128.png';
import './auth-brand.css';
import './auth-bootstrap.css';

export function AuthBootstrap({state,onRetry}:{state:AuthBootstrapState;onRetry:()=>void}){
 const checking=state.phase==='checking';
 return <main className="auth-page auth-bootstrap"><section className="auth-form" aria-labelledby="auth-bootstrap-title">
  <h1 className="auth-brand"><img src={appIcon} width={40} height={40} alt="" aria-hidden="true"/>ReadOS</h1>
  <h2 id="auth-bootstrap-title">{checking?'正在确认登录状态':'暂时无法确认登录状态'}</h2>
  <div className="auth-bootstrap-status" role="status" aria-live="polite" aria-busy={state.busy}>
   {state.busy&&<LoaderCircle className="spin" size={21} aria-hidden="true"/>}
   <p>{checking?'请稍候…':state.phase==='unavailable'?'请检查网络连接，然后重试。':'正在恢复连接，请稍候。'}</p>
  </div>
  {!checking&&<button type="button" className="primary auth-submit" disabled={state.busy} onClick={onRetry}><RefreshCw size={16} aria-hidden="true"/>重试</button>}
 </section></main>;
}
